// extracted by mini-css-extract-plugin
export default {"navTag":"vyW_AID_"};